import styled from 'styled-components';

const WidgetHeader = styled.header`
    display: grid;
    grid-template-columns: auto 1fr auto auto;
    align-items: center;
    padding: 0.5rem 1.2rem 0.5rem 1.2rem;
`;

export default WidgetHeader;
